<template lang="pug">
b-modal#manualApproveAffiliate(
  ref="manualApproveAffiliate"
  :title='$t("ui.combine.manual_approve_ticket")'
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th(colspan="2")
              span {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.member") }}
            td
              span {{ ticketDetail.member_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
            td
              span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
            td
              span {{ ticketDetail.target_bank_acc_remark }}
          tr(v-if="['AUD'].includes(getCurrencyCode)")
            td
              span {{ $t("ui.payid") }}
            td
              span {{ ticketDetail.target_bank_acc_remark_2 }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}
          
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    b-form-group(:label="$t('ui.sender_bank')").mb-0
      BankListWithdrawal(
        ref="senderBank"
        size="sm"
        type="array"
        :dirty="$v.sender_bank.$dirty"
        :error="$v.sender_bank.$error"
        v-model.trim.lazy="$v.sender_bank.$model"
        :disabled="loading"
        :operatorID="parentId"
      )
      ValidateResult(:value="$v.sender_bank" :name="$t('ui.sender_bank')")
    b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
      DebounceInput(
        size="sm"
        type="text"
        v-model="remark"
        :disabled="loading"
      )
    div(slot="modal-footer")
      SubmitButton.float-right(icon="fa fa-check" :text="$t('ui.approve')" @click="approveTicket()" size="sm" variant="info")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import BankListWithdrawal from "@/library/BankListWithdrawal";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankListWithdrawal,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    },
    parentId:{
      type: String,
      default: ""
    },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      memberDetail: null,
      sender_bank: '',
      remark: '',
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    sender_bank: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.sender_bank = '';
      this.remark = '';
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    approveTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmApproveTicket();
      }
    },
    confirmApproveTicket: function() {
      let url = config.ticketApproveWithdrawalAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
      };

      json.sender_bank_id = this.sender_bank.split(' - ')[0].trim();
      json.sender_bank_acc_no = this.sender_bank.split(' - ')[1].trim();

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.manualApproveAffiliate.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.manualApproveAffiliate.hide();
    },
  }
};
</script>
